module.exports = __webpack_public_path__ + "img/icon-apple-white.3e284782.svg";